import { Component } from '@angular/core';
import { HeroComponent } from './components/hero/hero.component';
import { AboutComponent } from './components/about/about.component';
import { EventCarouselComponent } from './components/event-carousel/event-carousel.component';
import { BudgetCtaComponent } from './components/budget-cta/budget-cta.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-root',
  imports: [
    HeroComponent,
    AboutComponent,
    EventCarouselComponent,
    BudgetCtaComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly particleSlots = Array.from({ length: 36 }, (_, index) => index);
}
